export const __encrypt = (str: string): string => {
  if (str !== undefined) return window.btoa(decodeURI(encodeURIComponent(str)));
  else return "";
};

export const __decrypt = (str: string): string => {
  if (str !== undefined) return decodeURIComponent(encodeURI(window.atob(str)));
  else return "";
};

export const __formatMoney = (
  val: number | string,
  dollarSign: boolean = true,
  decimals?: number
) => {
  try {
    if (typeof val === "string") val = parseFloat(val);
    return `${dollarSign ? "$ " : ""}${val
      .toFixed(decimals ? decimals : 2)
      .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`;
  } catch (e) {
    return "$ 0.00";
  }
};

export const __formatDateToDashboard = (date: string): string => {
  if (
    date !== "" &&
    date !== undefined &&
    date !== null &&
    date.split("-").length === 3 &&
    date !== "0000-00-00"
  ) {
    const _date = date.split("-");
    let dd = "",
      mm = "",
      yyyy = "";
    if (_date[0].length === 2) {
      dd = _date[0];
      mm = _date[1];
      yyyy = _date[2];
    } else {
      dd = _date[2];
      mm = _date[1];
      yyyy = _date[0];
    }
    return `${mm}-${dd}-${yyyy}`;
  } else {
    return "N/A";
  }
};
export const __leadingZero = (param: any) =>
  param.toString().length === 1 ? `0${param}` : param;

export const __setPayTerms = (
  customerPayTerms: string,
  shipmentPayTerms: string
) => {
  if (shipmentPayTerms !== "") return shipmentPayTerms;
  return customerPayTerms;
};
